import React from 'react'
import { StyleSheet } from 'react-native'

import { H5, Icon, XStack, colors as zetColors } from '@zet/design-system'

import { i18n } from '../../../localization'

const Header = () => {
  return (
    <XStack
      className="w-screen items-center justify-between px-3 py-3"
      style={styles.header}
    >
      <XStack className="items-center">
        <Icon
          size={24}
          type="StudyMaterialOutlined"
          color={zetColors.neutral.white100}
          className="mr-1"
        />
        <H5 className="text-white">
          {i18n.t('preRecordedTraining.trainings')}
        </H5>
      </XStack>
    </XStack>
  )
}
const styles = StyleSheet.create({
  header: { backgroundColor: zetColors.tertiary[150] },
})
export { Header }
